import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: ''
}

export const fetchLivingLegend = createAsyncThunk("fetchLivingLegend", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'livinglegend',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchLivingLegend.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchLivingLegend.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchLivingLegend.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
